import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/swiper.min.css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import { Button } from 'antd';

import ArrowLeft from '../../admin/assets/images/lake_manager/LeftArrow.png';
import ArrowRight from '../../admin/assets/images/lake_manager/RightArrow.png';

import { EffectCoverflow, Pagination, Autoplay, Navigation } from 'swiper';
import YouTube from 'react-youtube';

export function FisheryReviewSlider() {
  const Review = [
    {
      name: 'Mark Pallet - Owner',
      fisheryName: 'Elphicks Fisheries',
      remark: 'Its worked very well for this fishery',
      video: '0Wiq7HgFBBo',
    },
    {
      name: 'Chris Currie - Fishery Manager',
      fisheryName: 'Orchid Lakes',
      remark: 'swimbooker has certainly made my life easier',
      video: 'bek84pfmK-c',
    },
  ];

  return (
    <div>
      <div className='flex justify-center swiper-btn-group'>
        <Button
          className='swiper-btn carousel-btn carousel-prev swiper-button-prev'
          // disabled={numSlides <= 1 || (!infinite && currentSlide === 0)}
          onClick={() => {}}
        >
          <img src={ArrowLeft} alt='Left arrow' />
        </Button>
        <Button
          className='swiper-btn carousel-btn carousel-next swiper-button-next'
          // disabled={
          //   numSlides <= 1 || (!infinite && currentSlide === numSlides - 1)
          // }
          onClick={() => {}}
        >
          <img src={ArrowRight} alt='Right arrow' />
        </Button>
      </div>
      <Swiper
        effect={'coverflow'}
        grabCursor={true}
        autoplay={false}
        centeredSlides={true}
        slidesPerView={'auto'}
        pagination={true}
        modules={[Autoplay, EffectCoverflow, Pagination, Navigation]}
        breakpoints={{
          640: {
            slidesPerView: 1,
          },
          768: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 2,
          },
          1560: {
            slidesPerView: 2,
          },
        }}
        navigation={{
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        }}
      >
        {Review.map((review) => (
          <SwiperSlide>
            <div
              className='h-full w-full mg-top-25 mg-bottom-10'
              style={{ position: 'relative' }}
            >
              <YouTube
                style={{
                  width: '80%',
                  position: 'relative',
                  borderRadius: '10px',
                }}
                videoId={review.video}
                className='h-full youtube  mg-auto center cp  br10    '
                opts={{
                  height: '100%',
                  width: '80%',
                }}
              />
            </div>
            <div className='px-20 slider-additional-content'>
              <div className='grey-800 gMedium center'>{review.name}</div>
              <div className='grey-900 fs-20 gSemiBold center mg-bottom-15'>
                {review.fisheryName}
              </div>
              <div className='center mg-bottom-15'>
                <div
                  className='sb-blue-bg-400'
                  style={{ width: 62, height: 1 }}
                >
                  {' '}
                </div>
              </div>
              <div className='txt-center grey-900 fs-24 font-montserrat mg-bottom-20'>
                {`"${review?.remark}"`}
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      <div className='swiper-pagination'></div>
    </div>
  );
}
